import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, once = true }) => {
  const reduce = useReducedMotion();
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.09, delayChildren: delay } },
  };
  const lineVariant = reduce
    ? { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.5 } } }
    : { hidden: { y: "110%" }, visible: { y: "0%", transition: { duration: 0.7, ease: EASE } } };
  return (
    <motion.span
      className={`block ${className}`}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, margin: "-8% 0px" }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span variants={lineVariant} className={`block will-change-transform ${lineClassName}`}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal className="mb-12 flex items-center gap-4 md:mb-20">
    <span className="font-mono text-xs tracking-[0.2em] text-ember">{index}</span>
    <span className={`font-mono text-xs uppercase tracking-[0.2em] ${dark ? "text-paper/50" : "text-ink2"}`}>
      {label}
    </span>
    <span className={`h-px flex-1 ${dark ? "bg-paper/15" : "bg-line"}`} aria-hidden="true" />
  </Reveal>
);
